import createRoute       from '@widesk-ui/tools/createRoute';
import MobileSliderModel from '@models/website/MobileSliderModel';

const route = createRoute.dashboardFromModel(
	MobileSliderModel,
	'MobileSliderDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
